import { ref } from 'vue'
import { API_URL } from '../config'

const API_BASE = `${API_URL}?url=`

export function useAPI() {
  const loading = ref(false)
  const error = ref(null)

  const apiCall = async (method, endpoint, data = null) => {
    loading.value = true
    error.value = null

    try {
      const options = {
        method,
        headers: {
          'Content-Type': 'application/json'
        }
      }

      if (data && (method === 'POST' || method === 'PUT' || method === 'DELETE')) {
        options.body = JSON.stringify(data)
      }

      // Construir URL: si endpoint tiene ?, cambiar a &
      let url = `${API_BASE}${endpoint}`
      if (endpoint.includes('?')) {
        url = url.replace('?', '&')
      }

      console.log(`📡 [${method}] ${url}`, { data, options })

      const response = await fetch(url, options)
      const result = await response.json()

      console.log(`📊 Respuesta [${response.status}]:`, result)

      if (!response.ok) {
        throw new Error(result.message || `Error ${response.status} en solicitud API`)
      }

      return result.data
    } catch (err) {
      error.value = err.message
      console.error(`❌ Error en apiCall [${method}]:`, err)
      throw err
    } finally {
      loading.value = false
    }
  }

  // Competidores
  const getCompetidores = (categoriaId = null) => {
    const endpoint = categoriaId
      ? `/competidores?categoria_id=${categoriaId}`
      : '/competidores'
    return apiCall('GET', endpoint)
  }

  const getCompetidor = (id) => apiCall('GET', `/competidores/${id}`)

  // Categorías
  const getCategorias = () => apiCall('GET', '/categorias')

  // Torneos
  const getTorneos = () => apiCall('GET', '/torneos')

  const getTorneo = (id) => apiCall('GET', `/torneos/${id}`)

  const createTorneo = (nombre, fecha, categorias) =>
    apiCall('POST', '/torneos', { nombre, fecha, categorias })

  const updateTorneo = (id, estado) =>
    apiCall('PUT', `/torneos/${id}`, { estado })

  const deleteTorneo = (id) =>
    apiCall('DELETE', `/torneos/${id}`)

  // Llaves
  const generarLlaves = (torneoId, categoriaId) =>
    apiCall('POST', `/torneos/${torneoId}/generar-llaves?categoria_id=${categoriaId}`)

  const getBracket = (torneoId, categoriaId) =>
    apiCall('GET', `/torneos/${torneoId}/bracket?categoria_id=${categoriaId}`)

  const getByeStatus = (torneoId, categoriaId) =>
    apiCall('GET', `/torneos/${torneoId}/bye-status?categoria_id=${categoriaId}`)

  const siguienteRonda = (torneoId, categoriaId) =>
    apiCall('POST', `/torneos/${torneoId}/siguiente-ronda?categoria_id=${categoriaId}`)

  const limpiarLlaves = (torneoId, categoriaId) =>
    apiCall('POST', `/torneos/${torneoId}/limpiar-llaves?categoria_id=${categoriaId}`)

  // Votos
  const registrarVoto = (llaveId, numeroRound, juezId, voto, tipo = 'normal') =>
    apiCall('POST', '/votos', {
      llave_id: llaveId,
      numero_round: numeroRound,
      juez_id: juezId,
      voto,
      tipo
    })

  // Combates
  const getCombate = (id) => apiCall('GET', `/combates/${id}`)

  // Jueces
  const getJueces = () => apiCall('GET', '/jueces')

  const crearJuez = (nombre, usuario, password) =>
    apiCall('POST', '/jueces', { nombre, usuario, password })

  const eliminarJuez = (id) =>
    apiCall('DELETE', `/jueces/${id}`)

  const registrarConfirmacionJuez = (llaveId, juezId) =>
    apiCall('POST', '/judge-confirmation', { llave_id: llaveId, juez_id: juezId })

  const verificarConfirmaciones = (llaveId) =>
    apiCall('GET', `/check-confirmations?llave_id=${llaveId}`)

  return {
    loading,
    error,
    apiCall,
    // Competidores
    getCompetidores,
    getCompetidor,
    // Categorías
    getCategorias,
    // Torneos
    getTorneos,
    getTorneo,
    createTorneo,
    updateTorneo,
    deleteTorneo,
    // Llaves
    generarLlaves,
    getBracket,
    getByeStatus,
    siguienteRonda,
    limpiarLlaves,
    // Votos
    registrarVoto,
    // Combates
    getCombate,
    // Jueces
    getJueces,
    crearJuez,
    eliminarJuez,
    // Confirmaciones
    registrarConfirmacionJuez,
    verificarConfirmaciones
  }
}
